module.exports = "/static/media/microphone.3769a418.svg";